import {ISubscriptionStateModel} from './../../interfaces'

export const state: ISubscriptionStateModel = {
    dataIsLoading: false,
    subscription: null,
    plansList: []
}